import { CredentialsMindreader } from "@src/components/forms/CredentialsMindreader";
import { FormikInput } from "@src/components/forms/FormikInput";
import { HeaderText } from "@src/components/general/HeaderText";
import { VerticalFlexbox } from "@src/components/layout/Flexbox";
import { useFormikWizard } from "@src/components/layout/Wizard";
import { AccountCreate } from "../CreateAccount.types";

export const PersonalInfoStep = () => {
  useFormikWizard<AccountCreate>({
    formikFields: ["firstName", "lastName"],
  });

  return (
    <VerticalFlexbox gap="md">
      <HeaderText tag="h2" fontWeight={600}>
        Personal Information
      </HeaderText>
      <FormikInput name="firstName" label="First Name" required />
      <FormikInput name="middleName" label="Middle Name (optional)" />
      <FormikInput name="lastName" label="Last Name" required />
      <CredentialsMindreader
        selectedValueFieldName="credentials"
        queryValueFieldName="credentialsQuery"
      />
    </VerticalFlexbox>
  );
};
